import { useQuery } from '@tanstack/react-query';

import getBulkOrdering from '../api/getBulkOrdering';

const useBulkOrdering = (orderId?: string) => {
  return useQuery({
    queryKey: ['bulk-ordering', orderId],
    queryFn: () => getBulkOrdering(orderId as string),
    enabled: !!orderId,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    staleTime: 0
  });
};

export default useBulkOrdering;
